export default __webpack_public_path__ + "static/media/34.d6a459ca.jpg";